import { Collapse } from "ant-design-vue";
const { Panel, ...other } = Collapse;

const YwCollapse = {
	...other,
	Panel: {
		...Panel,
		name: "YwCollapsePanel",
	},
	name: "YwCollapse",
};
YwCollapse.install = function (Vue) {
	Vue.component(YwCollapse.name, Collapse);
	Vue.component(YwCollapse.Panel.name, Panel);
};

export default YwCollapse;
